<template>
   <section class="course__area pt-50 pb-120">
      <div class="container">
         <div class="row">
            <div class="col-xxl-4 col-xl-4 col-lg-4">
               <div class="course__sidebar pl-70">
                  <div class="course__sidebar-search mb-50">
                     <form action="#">
                        <input v-model="searchQuery" type="text" placeholder="Buscar por nome..."
                           class="form-control" />
                        <button type="submit">
                           <svg version="1.1" xmlns="http://www.w3.org/2000/svg"
                              xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 584.4 584.4"
                              style="enable-background:new 0 0 584.4 584.4;" xml:space="preserve">
                              <g>
                                 <g>
                                    <path class="st0"
                                       d="M565.7,474.9l-61.1-61.1c-3.8-3.8-8.8-5.9-13.9-5.9c-6.3,0-12.1,3-15.9,8.3c-16.3,22.4-36,42.1-58.4,58.4    c-4.8,3.5-7.8,8.8-8.3,14.5c-0.4,5.6,1.7,11.3,5.8,15.4l61.1,61.1c12.1,12.1,28.2,18.8,45.4,18.8c17.1,0,33.3-6.7,45.4-18.8    C590.7,540.6,590.7,499.9,565.7,474.9z" />
                                    <path class="st1"
                                       d="M254.6,509.1c140.4,0,254.5-114.2,254.5-254.5C509.1,114.2,394.9,0,254.6,0C114.2,0,0,114.2,0,254.5    C0,394.9,114.2,509.1,254.6,509.1z M254.6,76.4c98.2,0,178.1,79.9,178.1,178.1s-79.9,178.1-178.1,178.1S76.4,352.8,76.4,254.5    S156.3,76.4,254.6,76.4z" />
                                 </g>
                              </g>
                           </svg>
                        </button>
                     </form>
                  </div>
                  <div class="course__sidebar-widget grey-bg">
                     <div class="course__sidebar-info w-100">
                        <h3 class="course__sidebar-title">Filtros</h3>


                        <div class="w-100" style="position: relative; display: inline-block; margin-bottom: 10px;">
                           <label>Nível</label>
                           <select v-model="selectedLevel"
                              style="appearance: none; -webkit-appearance: none; border: none; outline: none; width: 100%; height: 35px; line-height: 37px; padding: 0 20px; font-size: 15px; color: #53545b; font-weight: 500; text-transform: capitalize; border-radius: 4px; padding-right: 40px;">
                              <option>Todos</option>
                              <option value="Graduação">Graduação</option>
                              <option value="Especialização">Especialização</option>
                              <option value="Residência">Residência</option>
                              <option value="Mestrado">Mestrado</option>
                              <option value="Doutorado">Doutorado</option>
                              <option value="Pós-doutorado">Pós-doutorado</option>
                           </select>

                           <!-- Ícone Font Awesome (unicode f107 = fa-angle-down) -->
                           <i class="fas fa-angle-down"
                              style="position: absolute; top: 70%; right: 15px; transform: translateY(-50%); pointer-events: none; font-size: 0.9em; color: #53545b; font-weight: 500;"></i>
                        </div>
                        <div class="w-100" style="position: relative; display: inline-block; margin-bottom: 10px;">
                           <label>Curso</label>
                           <select v-model="selectedCourseFilter"
                              style="appearance: none; border: none; outline: none; width: 100%; height: 35px; line-height: 37px; padding: 0 20px; font-size: 15px; color: #53545b; font-weight: 500; text-transform: capitalize; border-radius: 4px; padding-right: 40px;">
                              <option>Todos</option>
                              <option>Biologia</option>
                              <option>Matemática</option>
                              <option>Medicina</option>
                           </select>

                           <!-- Ícone Font Awesome (unicode f107 = fa-angle-down) -->
                           <i class="fas fa-angle-down"
                              style="position: absolute; top: 70%; right: 15px; transform: translateY(-50%); pointer-events: none; font-size: 0.9em; color: #53545b; font-weight: 500;"></i>
                        </div>

                        <div class="w-100" style="position: relative; display: inline-block; margin-bottom: 10px;">
                           <label>Ano</label>
                           <select v-model="selectedYear"
                              style="appearance: none; border: none; outline: none; width: 100%; height: 35px; line-height: 37px; padding: 0 20px; font-size: 15px; color: #53545b; font-weight: 500; text-transform: capitalize; border-radius: 4px; padding-right: 40px;">
                              <option>Todos</option>
                              <option>2025</option>
                              <option>2024</option>
                              <option>2023</option>
                              <option>2022</option>
                              <option>2021</option>
                              <option>2020</option>
                           </select>

                           <!-- Ícone Font Awesome (unicode f107 = fa-angle-down) -->
                           <i class="fas fa-angle-down"
                              style="position: absolute; top: 70%; right: 15px; transform: translateY(-50%); pointer-events: none; font-size: 0.9em; color: #53545b; font-weight: 500;"></i>
                        </div>


                     </div>

                  </div>

               </div>
            </div>
            <div class="col-xxl-8 col-xl-8 col-lg-8">
               <div class="course__tab-inner grey-bg-2 mb-50 d-sm-flex justify-content-between align-items-center">
                  <div class="course__tab-wrapper d-flex align-items-center">
                     <div class="course__view">
                        <h4>
                           Mostrando
                           {{ (currentPage - 1) * pageSize + 1 }} –
                           {{ Math.min(currentPage * pageSize, filteredEgressos.length) }}
                           de {{ filteredEgressos.length }}
                        </h4>
                     </div>

                  </div>
                  <div class="course__sort d-flex justify-content-sm-end">
                     <div class="page-size-selector d-flex align-items-center">
                        <label for="pageSizeSelect" style="margin-right: 5px; font-weight: 500;">Mostrar</label>
                        <select id="pageSizeSelect" v-model.number="pageSize"
                           style="height: 35px; line-height: 35px; padding: 0 10px; border: 1px solid #eef0f6; border-radius:4px; font-size: 14px; margin-right: 5px;">
                           <option v-for="size in pageSizeOptions" :key="size" :value="size">
                              {{ size }}
                           </option>
                        </select>
                        <span>por página</span>
                     </div>
                  </div>
               </div>

               <div class="course__tab-conent">

                  <div class="tab-content" id="courseTabContent">
                     <div class="tab-pane fade show active" id="grid" role="tabpanel" aria-labelledby="grid-tab">
                        <div class="row">
                        <!-- {{ lista }} -->

                           <div v-for="group in paginatedGroups" :key="group.nome"
                              class="col-xxl-12 col-xl-12 col-lg-12 col-md-12">
                              <div class="course__item white-bg mb-30 fix">
                                 <div class="course__content" style="padding: 15px 30px;">
                                    <div class="course__teacher d-flex align-items-center mb-10">
                                       <h6>{{ group.nome }}</h6>
                                    </div>

                                    <!-- para cada “curso” desse nome -->
                                    <div v-for="curso in group.formacoes" :key="curso.id_formacao" @click="openModal(curso)"
                                       onmouseover="this.style.textDecoration='underline'"
                                       onmouseout="this.style.textDecoration='none'"
                                       class="course__meta d-flex align-items-center justify-content-between mb-0 "
                                       style="cursor: pointer;">
                                       <div class="course__lesson">
                                          <span>
                                             <i class="fal fa-graduation-cap"></i>{{ curso.tipo }} – {{ curso.nome_curso }}
                                             – {{ curso.ano_conclusao }}
                                          </span>
                                       </div>
                                       <!-- <div class="course__rating">
                                          <button type="button" class="link-btn"
                                             style="font-size:14px; background:none;">
                                             Ver
                                             <i class="far fa-arrow-right"></i><i class="far fa-arrow-right"></i>
                                          </button>
                                       </div> -->
                                    </div>

                                 </div>
                              </div>
                           </div>


                        </div>
                     </div>


                  </div>

                  <!-- Pagination start-->
                  <div class="row">
                     <div class="col-xxl-12">
                        <div class="basic-pagination mt-30">
                           <ul class="pagination-list">
                              <li :class="{ disabled: currentPage === 1 }">
                                 <button class="pagination-btn prev-btn" @click="changePage(1)"
                                    :disabled="currentPage === 1">
                                    <i class="far fa-arrow-left"></i>
                                 </button>
                              </li>
                              <!-- “Anterior” -->
                              <li :class="{ disabled: currentPage === 1 }">
                                 <button class="pagination-btn prev-btn" @click="prevPage"
                                    :disabled="currentPage === 1">
                                    Ant <i class="arrow_left"></i><i class="arrow_left"></i>
                                 </button>
                              </li>

                              <!-- números de página -->
                              <li v-for="page in visiblePages" :key="page">
                                 <button class="pagination-btn" :class="{ active: page === currentPage }"
                                    @click="changePage(page)">
                                    {{ page }}
                                 </button>
                              </li>

                              <!-- “Próximo” -->
                              <li :class="{ disabled: currentPage === totalPages }">
                                 <button class="pagination-btn next-btn" @click="nextPage"
                                    :disabled="currentPage === totalPages">
                                    Próx <i class="arrow_right"></i><i class="arrow_right"></i>
                                 </button>
                              </li>

                              <li :class="{ disabled: currentPage === totalPages }">
                                 <button class="pagination-btn next-btn" @click="changePage(totalPages)"
                                    :disabled="currentPage === totalPages">
                                    <i class="far fa-arrow-right"></i>
                                 </button>
                              </li>
                           </ul>
                        </div>
                     </div>
                  </div>

               </div>
            </div>



         </div>
      </div>

   </section>

   <!-- Modal de Detalhes -->
   <div v-if="showModal" class="modal-overlay" @click.self="closeModal">
      <div class="modal-content">
         <button class="modal-close" @click="closeModal">×</button>
         <h4 class="mb-0">Egresso: {{ selectedCourse.nome }} </h4>
         <hr style="margin-bottom: 0px;">
         <div class="course__tag-2 "
            style="padding: 12px; margin-bottom: 20px;background-color: #f0f0f0; border-bottom: 1px solid #eef0f6; "><i
               class="fal fa-graduation-cap"></i>Formação
            Acadêmica</div>
         <div class="row" style="padding: 0px 20px 0px 20px;">
            <div class="col-md-6">
               <p style="margin-bottom: 0px;"><strong>Tipo:</strong> {{ selectedCourse.tipo }}</p>
            </div>
            <div class="col-md-6">
               <p style="margin-bottom: 0px;"><strong>Curso:</strong> {{ selectedCourse.nome_curso }}</p>
            </div>
            <div class="col-md-6">
               <p style="margin-bottom: 0px;"><strong>Foi Cotista:</strong> {{ selectedCourse.foi_cotista ? 'Sim' : 'Não' }}</p>
            </div>
            <div class="col-md-6">
               <p style="margin-bottom: 0px;"><strong>Descrição da Cota:</strong> {{ selectedCourse.descricao_cota }}</p>
            </div>
            <div class="col-md-6">
               <p style="margin-bottom: 0px;"><strong>Observações da Cota:</strong> {{ selectedCourse.observacoes_cota }}</p>
            </div>
            <div class="col-md-6">
               <p style="margin-bottom: 0px;"><strong>Ano de Conclusão:</strong> {{ selectedCourse.ano_conclusao }}</p>
            </div>
            <div class="col-md-6">
               <p style="margin-bottom: 0px;"><strong>Participação Científica:</strong> {{ selectedCourse.participacao_cientifica }}</p>
            </div>
            <div class="col-md-6">
               <p style="margin-bottom: 0px;"><strong>Participação em Extensão:</strong> {{ selectedCourse.participacao_extensao }}</p>
            </div>
            <div class="col-md-6">
               <p style="margin-bottom: 0px;"><strong>Participação em Ensino:</strong> {{ selectedCourse.participacao_ensino }}</p>
            </div>
            <div class="col-md-6">
               <p style="margin-bottom: 0px;"><strong>Participação em Monitoria:</strong> {{ selectedCourse.participacao_monitoria }}</p>
            </div>
            <div class="col-md-6">
               <p style="margin-bottom: 0px;"><strong>Foi Bolsista:</strong> {{ selectedCourse.foi_bolsista }}</p>
            </div>
            <div class="col-md-6">
               <p style="margin-bottom: 0px;"><strong>Agência Fomentadora:</strong> {{ selectedCourse.agencia_fomentadora }}</p>
            </div>


            <div class="col-md-6">
               <strong>Avaliação dos Itens:</strong>
               <ul>
                  <li>► Avaliação geral com o curso: {{ selectedCourse.avaliacaoItems[0] }}</li>
                  <li>► Salas de aula: {{ selectedCourse.avaliacaoItems[1] }}</li>
                  <li>► Bibliotecas: {{ selectedCourse.avaliacaoItems[2] }}</li>
                  <li>► Laboratórios de ensino: {{ selectedCourse.avaliacaoItems[3] }}</li>
                  <li>► Laboratórios de pesquisa: {{ selectedCourse.avaliacaoItems[4] }}</li>
                  <li>► Currículo do curso: {{ selectedCourse.avaliacaoItems[5] }}</li>
                  <li>► Professores do curso: {{ selectedCourse.avaliacaoItems[6] }}</li>
                  <li>► Materiais e métodos de ensino: {{ selectedCourse.avaliacaoItems[7] }}</li>
                  <li>► Coordenação do curso: {{ selectedCourse.avaliacaoItems[8] }}</li>
                  <li>► Secretaria do curso: {{ selectedCourse.avaliacaoItems[9] }}</li>
                  <li>► Flexibilidade de horários: {{ selectedCourse.avaliacaoItems[10] }}</li>
                  <li>► Espaços de convivência: {{ selectedCourse.avaliacaoItems[11] }}</li>
               </ul>
            </div>
            <div class="col-md-6">
               <p style="margin-bottom: 0px;"><strong>Observações:</strong> {{ selectedCourse.observacoes }}</p>
            </div>
         </div>
         <hr style="margin-bottom: 0px;">
         <div class="course__tag-2 "
            style="padding: 12px; margin-bottom: 20px;background-color: #f0f0f0; border-bottom: 1px solid #eef0f6; "><i
               class="fal fa-flask"></i>Contribuições Científicas,
            Profissionais e Sociais</div>


         <div class="row" style="padding: 0px 20px 0px 20px;">
            <div class="col-md-12 mb-10">
               <strong>Atividades e Contribuições:</strong>
               <ul>
                  <li v-for="atividade in selectedCourse.atividades_contribuicoes" :key="atividade">► {{ atividadesContribuicoesOptions.filter(a => a.id === atividade)[0].descricao }} </li>
               </ul>
            </div>
            <div class="col-md-6">
               <p style="margin-bottom: 0px;"><strong>Impacto na Pesquisa:</strong> {{ selectedCourse.impacto_pesquisa }}</p>
            </div>
            <div class="col-md-6">
               <p style="margin-bottom: 0px;"><strong>Melhoria de Processos:</strong> {{ selectedCourse.melhoria_processos }}</p>
            </div>
            <div class="col-md-6">
               <p style="margin-bottom: 0px;"><strong>Inovação e Empreendedorismo:</strong> {{ selectedCourse.inovacao_empreendedorismo }}</p>
            </div>
            <div class="col-md-6">
               <p style="margin-bottom: 0px;"><strong>Startup/Negócios:</strong> {{ selectedCourse.startup_negocios }}</p>
            </div>
            <div class="col-md-6">
               <p style="margin-bottom: 0px;"><strong>Responsabilidade Social:</strong> {{ selectedCourse.responsabilidade_social }}</p>
            </div>
            <div class="col-md-6">
               <p style="margin-bottom: 0px;"><strong>Atividades de Responsabilidade Social:</strong> {{ selectedCourse.atividades_responsabilidade }}</p>
            </div>
         </div>
         <hr style="margin-bottom: 0px;">
         <div class="course__tag-2 "
            style="padding: 12px; margin-bottom: 20px;background-color: #f0f0f0; border-bottom: 1px solid #eef0f6; "><i
               class="fal fa-briefcase"></i>Empregabilidade</div>
         <div class="row" style="padding: 0px 20px 0px 20px;">
            <ul>
               <li><strong> Mercado de trabalho nos últimos 12 meses:</strong> {{ selectedCourse.vinculos_empregaticios[0].mercado_trabalho_12_meses }}</li>
               <li><strong>Situação Atual:</strong> {{ selectedCourse.vinculos_empregaticios[0].situacao_atual }}</li>
               <li><strong>Setor de Atuação:</strong> {{ selectedCourse.vinculos_empregaticios[0].setor_atuacao }}</li>
               <li><strong>Jornada de Trabalho:</strong> {{ selectedCourse.vinculos_empregaticios[0].jornada_trabalho }}</li>
               <li><strong> Instituição Atual:</strong> {{ selectedCourse.vinculos_empregaticios[0].instituicao_atual }}</li>
               <li><strong> Salário Médio:</strong> {{ selectedCourse.vinculos_empregaticios[0].salario_medio }}</li>
               <li><strong> Impacto na Renda:</strong> {{ selectedCourse.vinculos_empregaticios[0].impacto_renda }}</li>
               <li><strong> Qualificação para o Mercado:</strong> {{ selectedCourse.vinculos_empregaticios[0].qualificacao_mercado }}</li>
            </ul>
         </div>
         <hr style="margin-bottom: 0px;">
         <div class="course__tag-2"
            style="padding: 12px; margin-bottom: 20px;background-color: #f0f0f0; border-bottom: 1px solid #eef0f6; "><i
               class="fal fa-user-tie"></i>Gestão ou Liderança</div>
         <div class="row" style="padding: 0px 20px 0px 20px;">
            <p style="margin-bottom: 0px;"><strong>Ocupa Posição de Gestão:</strong> {{ selectedCourse.posicoes_gestao[0].ocupaPosicao }}</p>
            <p style="margin-bottom: 0px;"><strong>Detalhe função e instituição:</strong> {{ selectedCourse.posicoes_gestao[0].detalhesPosicao }}</p>
         </div>
      </div>
   </div>

</template>

<script>
// import egressos from '@/data/egressos.json';
import keycloak from '@/keycloak';

export default {
   name: 'CourseSidebarArea',
   data() {
      return {
         keycloak,
         backend: process.env.VUE_APP_BACKEND_URL,
         lista: [],
         error: null,
         loading: true,
         egressosItems: [],
         searchQuery: '',
         selectedLevel: 'Todos',
         selectedCourseFilter: 'Todos',
         selectedYear: 'Todos',
         pageSizeOptions: [5, 10, 15, 30, 50],
         currentPage: 1,
         pageSize: 5,
         showModal: false,
         selectedCourse: null,
         atividadesContribuicoesOptions: [
         { id: 1, descricao: "Participou de eventos científicos" },
         { id: 2, descricao: "Publicou Livro(s) e/ou Capítulos de Livro(s)" },
         { id: 3, descricao: "Desenvolveu patente ou registro de software" },
         { id: 4, descricao: "Recebeu Prêmio científico ou profissional" },
         { id: 5, descricao: "Colaborou em Rede de Pesquisa" },
         { id: 6, descricao: "Contribuiu para Políticas e Práticas relevantes na área de formação" },
         { id: 7, descricao: "Não realizei nenhuma das atividades acima descritas" }
         ],
      };
   },
   computed: {
      // groupedEgressos() {
      //    const mapa = {};
      //    this.filteredEgressos.forEach(e => {
      //       if (!mapa[e.nome]) mapa[e.nome] = [];
      //       //mapa[e.nome].push(e);
      //       // cada egresso pode ter várias formações
      //    e.formacoes?.forEach(f => {
      //       mapa[e.nome].push(f);
      //    });
      //    });
      //    // transforma em array [{ nome, cursos: […] }, …]
      //    return Object.entries(mapa).map(([nome, cursos]) => ({ nome, cursos }));
      // },
      filteredEgressos() {
         const q = this.searchQuery.trim().toLowerCase();

         return this.egressosItems
            .map(e => {
               // filtra as formações dentro de cada egresso
               let cursos = e.formacoes || [];

               if (q) {
               cursos = cursos.filter(f =>
                  e.nome.toLowerCase().includes(q) ||
                  f.tipo.toLowerCase().includes(q) ||
                  f.nome_curso.toLowerCase().includes(q)
               );
               }

               if (this.selectedLevel !== 'Todos') {
               cursos = cursos.filter(f => f.tipo === this.selectedLevel);
               }

               if (this.selectedCourseFilter !== 'Todos') {
               cursos = cursos.filter(f => f.nome_curso === this.selectedCourseFilter);
               }

               if (this.selectedYear !== 'Todos') {
               cursos = cursos.filter(f => String(f.ano_conclusao) === this.selectedYear);
               }

               return {
               ...e,                // mantém dados pessoais (nome, cpf, etc.)
               formacoes: cursos    // substitui pelo array já filtrado
               };
            })
            // remove egressos que ficaram sem cursos
            .filter(e => e.formacoes.length > 0);
      },
      // filteredEgressos() {
      //    let list = [...this.egressosItems];
      //    const q = this.searchQuery.trim().toLowerCase();

      //    if (q) {
      //       list = list.filter(e =>
      //          e.nome.toLowerCase().includes(q) ||
      //          e.formacoes?.some(f =>
      //          f.tipo.toLowerCase().includes(q) ||
      //          f.nome_curso.toLowerCase().includes(q)
      //          )
      //       );
      //    }

      //    if (this.selectedLevel !== 'Todos') {
      //       list = list.filter(e =>
      //          e.formacoes.some(f => f.tipo === this.selectedLevel)
      //       );
      //    }

      //    if (this.selectedCourseFilter !== 'Todos') {
      //       list = list.filter(e =>
      //          e.formacoes.some(f => f.nome_curso === this.selectedCourseFilter)
      //       );
      //    }

      //    if (this.selectedYear !== 'Todos') {
      //       list = list.filter(e =>
      //          e.formacoes.some(f => String(f.ano_conclusao) === this.selectedYear)
      //       );
      //    }

      //    return list;
      // },
      totalPages() {
         return Math.ceil(this.filteredEgressos.length / this.pageSize);
      },

      // 4) pega só o fatiamento de grupos para a página atual
      paginatedGroups() {
         const start = (this.currentPage - 1) * this.pageSize;
         return this.filteredEgressos.slice(start, start + this.pageSize);
      },
      paginatedEgressos() {
         const start = (this.currentPage - 1) * this.pageSize;
         return this.filteredEgressos.slice(start, start + this.pageSize);
      },
      visiblePages() {
         const total = this.totalPages;
         const delta = 2; // quantas páginas antes e depois da atual
         let start = Math.max(1, this.currentPage - delta);
         let end = Math.min(total, this.currentPage + delta);

         // se estiver no início, expande para a direita
         if (this.currentPage <= delta + 1) {
            start = 1;
            end = Math.min(total, 1 + delta * 2);
         }
         // se estiver no fim, expande para a esquerda
         if (this.currentPage >= total - delta) {
            end = total;
            start = Math.max(1, total - delta * 2);
         }

         const pages = [];
         for (let p = start; p <= end; p++) {
            pages.push(p);
         }
         return pages;
      },
   },
   watch: {
      // sempre que filtros ou busca mudarem, volta à página 1
      searchQuery() { this.currentPage = 1; },
      selectedLevel() { this.currentPage = 1; },
      selectedCourseFilter() { this.currentPage = 1; },
      selectedYear() { this.currentPage = 1; },
      pageSize() {
         this.currentPage = 1;
      },
   },
   methods: {
      changePage(page) { this.currentPage = page; },
      prevPage() { if (this.currentPage > 1) this.currentPage--; },
      nextPage() { if (this.currentPage < this.totalPages) this.currentPage++; },
      openModal(course) { this.selectedCourse = course; this.showModal = true; },
      closeModal() { this.showModal = false; this.selectedCourse = null; },
      async carregarDados(){
         this.loading = true;
         this.error = null;
         try {
            const response = await fetch(this.backend + '/listar/', {
               method: 'GET',
               headers: {
                     'Content-Type': 'application/json',
                     'Authorization': `Bearer ${this.keycloak.token}`,
               }
            });
            if (!response.ok) {
               throw new Error(`HTTP error! status: ${response.status}`);
            }
            const json = await response.json();
            this.lista = json.message;
            this.egressosItems = this.lista;
            
         } catch (e) {
            this.error = e.message;
         } finally {
            this.loading = false;
         }
      }
   },
   mounted() {
      this.carregarDados();
   },
};
</script>
<style scoped>
/* backdrop do modal */
.modal-overlay {
   position: fixed;
   top: 0;
   left: 0;
   width: 100%;
   height: 100%;
   background: rgba(0, 0, 0, 0.5);
   display: flex;
   align-items: center;
   justify-content: center;
   z-index: 1000;
   overflow-y: auto;
   /* permite rolar todo o overlay caso o conteúdo seja muito alto */
}

/* conteúdo do modal */
.modal-content {
   background: #fff;
   padding: 20px;
   border-radius: 4px;
   max-width: 800px;
   width: 90%;
   position: relative;
   max-height: 80vh;
   /* limita a altura ao viewport */
   overflow-y: auto;
   /* ativa a rolagem interna */
}

/* botão de fechar */
.modal-close {
   position: absolute;
   top: 10px;
   right: 10px;
   border: none;
   background: transparent;
   font-size: 1.5rem;
   cursor: pointer;
}

.pagination-list {
   display: flex;
   align-items: center;
   padding: 0;
   margin: 0;
   list-style: none;
}

.pagination-list li {
   margin-right: 2px;
}

.pagination-btn {
   width: 40px;
   height: 40px;
   line-height: 38px;
   text-align: center;
   border: 1px solid #eef0f6;
   border-radius: 4px;
   font-weight: 500;
   font-size: 16px;
   background: #fff;
   color: #0e1133;
   cursor: pointer;
   transition: background 0.2s;
}

.pagination-btn.active {
   background: #174171;
   color: #fff;
   border-color: #174171;
}

.pagination-btn:disabled {
   color: #ccc;
   cursor: not-allowed;
   background: transparent;
   border-color: #eef0f6;
}

/* botões “Ant” e “Próx” */
.prev-btn,
.next-btn {
   width: 40px;
   height: 40px;
   line-height: 38px;
   text-align: center;
   border: 1px solid #eef0f6;
   border-radius: 4px;
   font-weight: 500;
   font-size: 16px;
   background: #fff;
   color: #0e1133;
   cursor: pointer;
   transition: background 0.2s;
}

.prev-btn:disabled,
.next-btn:disabled {
   color: #ccc;
}
</style>